import React from 'react'

import { cva, type VariantProps } from 'class-variance-authority'

import { Icons } from '@/components/atoms/Icons/Icons.tsx'
import { MobileRequestToggle } from '@/components/atoms/MobileRequestToggle/MobileRequestToggle.tsx'
import { cn } from '@/lib/utils.ts'

const mobileRequestVariants = cva(
  'inline-flex items-center gap-8 rounded-allocated border border-solid border-gray-600 bg-black pl-2 w-[330px] justify-between',
  {
    variants: {
      state: {
        open: '',
        exceedsThreshold: '',
        pause: '',
        adminPause: '',
      },
    },
    defaultVariants: {
      state: 'open',
    },
  }
)

const textVariants = cva('flex items-center gap-1.5 text-base whitespace-nowrap', {
  variants: {
    state: {
      open: 'text-green-400 *:fill-green-400',
      exceedsThreshold: 'text-orange-400 *:fill-orange-400',
      pause: 'text-red-500 *:fill-red-500',
      adminPause: 'text-red-500 *:fill-red-500',
    },
    hover: {
      true: '',
      false: '',
    },
  },
  defaultVariants: {
    state: 'open',
  },
})

export interface MobileRequestLabels {
  mobileRequestOpen: string
  mobileRequestPaused: string
  mobileRequestClosed: string
}

export interface MobileRequestProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof mobileRequestVariants> {
  labels: MobileRequestLabels
}

export const MobileRequest = React.forwardRef<HTMLButtonElement, MobileRequestProps>(
  ({ className, state = 'open', labels, ...props }, ref) => (
    <div className={cn(mobileRequestVariants({ state, className }))}>
      <div className={cn(textVariants({ state }))}>
        <Icons.mobileFriendly className="h-[22px]" />
        <p className={cn('font-bold select-none')}>
          {state === 'open'
            ? labels.mobileRequestOpen
            : state === 'exceedsThreshold'
              ? labels.mobileRequestPaused
              : labels.mobileRequestClosed}
        </p>
      </div>

      {props.disabled ? (
        <div className="h-[33px]" />
      ) : (
        <MobileRequestToggle state={state === 'adminPause' ? 'pause' : state} ref={ref} {...props} />
      )}
    </div>
  )
)
